module.exports = __webpack_public_path__ + "img/logo-ar.b7d7001a.png";